var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"complete-chip",attrs:{"outlined":"","color":"primary"}},[_c('v-icon',{attrs:{"color":"primary","left":""}},[_vm._v("mdi-card-account-mail")]),_vm._v("参加済 ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }